import React, { useEffect } from "react";
import {
    FaMobileAlt,
    FaBolt,
    FaRocket,
    FaPuzzlePiece
} from "react-icons/fa";
import "./BenefitsReactNative.css";

const BenefitsReactNative = () => {

    useEffect(() => {

        const cards = document.querySelectorAll(".rb-card");

        cards.forEach((card, i) => {

            card.style.opacity = "0";
            card.style.transform = "translateX(-80px)";

            setTimeout(() => {

                card.style.transition = ".9s ease";

                card.style.opacity = "1";

                card.style.transform = "translateX(0)";

            }, i * 180);

        });

    }, []);

    const benefits = [
        {
            title: "Cross Platform Apps",
            desc: "Build Android & iOS apps together using a single scalable codebase.",
            icon: <FaMobileAlt />,
        },
        {
            title: "Fast Performance",
            desc: "Deliver smooth animations and native-like mobile experiences.",
            icon: <FaBolt />,
        },
        {
            title: "Rapid Development",
            desc: "Hot reload speeds up development and testing workflow.",
            icon: <FaRocket />,
        },
        {
            title: "Reusable Components",
            desc: "Reusable architecture reduces time and maintenance cost.",
            icon: <FaPuzzlePiece />,
        },
    ];

    return (
        <>
            <section
                style={{
                    position: "relative",
                    padding: "140px 24px",
                    background: "#0d0d0d",
                    overflow: "hidden",
                }}
            >

                {/* Animated Glow */}
                <div className="rb-glow rb-glow1"></div>
                <div className="rb-glow rb-glow2"></div>

                <div
                    style={{
                        maxWidth: "1300px",
                        margin: "0 auto",
                        position: "relative",
                        zIndex: 2,
                    }}
                >

                    {/* TOP */}
                    <div
                        style={{
                            textAlign: "center",
                            marginBottom: "90px",
                        }}
                    >

                        <div className="rb-mini-title">
                            ⚛ React Native Benefits
                        </div>

                        <h2 className="rb-heading">
                            Why Businesses Love{" "} <br />
                            <span>React Native</span>
                        </h2>

                        <p className="rb-desc">
                            React Native combines speed, scalability and
                            modern UI capabilities to create high-quality
                            mobile experiences faster than traditional
                            app development.
                        </p>

                    </div>

                    {/* HORIZONTAL STACK */}
                    <div className="rb-stack">

                        {benefits.map((item, i) => (

                            <div
                                key={i}
                                className="rb-card"
                                onMouseEnter={(e) => {

                                    e.currentTarget.style.transform =
                                        "translateX(16px)";

                                    e.currentTarget.style.borderColor =
                                        "#E8212A";

                                }}
                                onMouseLeave={(e) => {

                                    e.currentTarget.style.transform =
                                        "translateX(0px)";

                                    e.currentTarget.style.borderColor =
                                        "rgba(255,255,255,.08)";

                                }}
                            >

                                {/* LEFT */}
                                <div className="rb-left">

                                    <div className="benefit-icon">
                                        {item.icon}
                                    </div>

                                </div>

                                {/* CENTER */}
                                <div className="rb-center">

                                    <h3>{item.title}</h3>

                                    <p>{item.desc}</p>

                                </div>

                                {/* RIGHT */}
                                <div className="rb-right">

                                    <div className="rb-arrow">
                                        →
                                    </div>

                                </div>

                                {/* hover glow */}
                                <div className="rb-hover-glow"></div>

                            </div>

                        ))}

                    </div>

                </div>
                <style>
                    {`.benefit-icon{
    width:72px;
    height:72px;
    display:flex;
    align-items:center;
    justify-content:center;
    border-radius:22px;
    background:linear-gradient(
        135deg,
        #E8212A,
        #ff646b
    );

    color:#fff;
    font-size:30px;

    box-shadow:
        0 15px 35px rgba(232,33,42,.25);

    transition:all .4s ease;
}

.benefit-card:hover .benefit-icon{
    transform:
        translateY(-8px)
        rotate(-6deg)
        scale(1.08);

    box-shadow:
        0 25px 60px rgba(232,33,42,.35);
}`}
                </style>
            </section>
        </>
    );
};

export default BenefitsReactNative;